import { useCallback, useEffect, useState } from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { ListarTipoTransaccionTC } from "../../../Service/Service.util";
import { Input } from "antd";
import { useSelector } from "react-redux";

function ModalTarjetas({ data }) {

    const { show, handleClose, handleAgregarDatoBancarios } = data;
    const pagos = useSelector((state) => state.formapagoredux.pagos ) || [];
    const [loading, setLoading] = useState(false);
    const [datoTarjeta, setDatoTarjeta] = useState({ tipo_ping: "", num_transaccion: "", num_lote: "", tipo: "TC" });
    const [listaTransaccion, setListaTransaccion] = useState([]);
    const [isEditing, setIsEditing] = useState(false);

    const guardarDatosBancarios = async () => {
        setLoading(true);
        handleAgregarDatoBancarios(datoTarjeta);
        setDatoTarjeta({ tipo_ping: "",num_transaccion: "", num_lote: "", tipo: "TC" });
        setLoading(false);
    }

    const fetchInitialData = useCallback(async () => {
        const tipoTransaccionTC = await ListarTipoTransaccionTC();
        if (tipoTransaccionTC && tipoTransaccionTC.success) {
            setListaTransaccion(tipoTransaccionTC.data);
        }

    }, []);

    const handleSeleccionarTransaccion = (codigo) => {
        setDatoTarjeta({...datoTarjeta, tipo_ping: codigo });
    };

    const handleChange = (event) => {
        const value = event.target.value.replace(/[^0-9.]/g, "");
        setDatoTarjeta({ ...datoTarjeta, [event.target.name]: value });
    };

    useEffect(() => {
        if (show && pagos.length > 0) {
            const pagoTC = pagos.find(pago => pago.datosBancario.tipo === "TC");

            if (pagoTC) {
                setIsEditing(true);
                setDatoTarjeta({
                    tipo_ping: pagoTC.datosBancario.tipo_ping || "",
                    num_transaccion: pagoTC.datosBancario.num_transaccion || "",
                    num_lote: pagoTC.datosBancario.num_lote || "",
                    tipo: "TC",
                });
            }
        }
    }, [show, pagos]);

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="md">
            <Modal.Header closeButton>
                <Modal.Title>{ isEditing ? 'Actualizar' : 'Agregar'} Datos de Tarjeta</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="no_cheque">
                                    Seleccione Tipo Transacci&oacute;n:
                                </label>

                                <div className="d-flex flex-wrap justify-content-start pb-2">
                                    {listaTransaccion.length > 0 ? (
                                        listaTransaccion.map((transaccion) => (
                                            <button
                                                key={transaccion.tipo_transaccion_id}
                                                className={`btn m-1 ${datoTarjeta.tipo_ping === transaccion.codigo
                                                        ? "btn-primary"
                                                        : "btn-outline-primary"
                                                    }`}
                                                onClick={() => handleSeleccionarTransaccion(transaccion.codigo)}
                                            >
                                                {transaccion.transaccion}
                                            </button>
                                        ))
                                    ) : (
                                        <p className="text-muted">Cargando tipos de transacción...</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="num_transaccion">
                                    No. de Transacci&oacute;n
                                </label>
                                <Input
                                    type="text"
                                    className="me-2 flex-grow-1"
                                    id="num_transaccion"
                                    value={datoTarjeta.num_transaccion}
                                    name="num_transaccion"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>   

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="num_lote">
                                    No. de Lote
                                </label>
                                <Input
                                    type="text"
                                    className="me-2 flex-grow-1"
                                    id="num_lote"
                                    value={datoTarjeta.num_lote}
                                    name="num_lote"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>              

            </Modal.Body>

            <Modal.Footer>
                <div className="mb-3 text-end">
                    <button className="btn btn-light m-1" disabled={loading} onClick={handleClose}>Cancelar</button>
                    <button className="btn btn-primary m-1" onClick={guardarDatosBancarios} disabled={loading || !datoTarjeta.tipo_ping || !datoTarjeta.num_transaccion || !datoTarjeta.num_lote}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) : isEditing ? 'Actualizar' : 'Agregar' }
                    </button>
                </div>
            </Modal.Footer>

        </Modal>
    )

}

export default ModalTarjetas;